import _ from 'lodash';
export function makePercentage(p, d = 2) {
	return _.round(p * 100, d);
}
export function formatPercentage(p, d = 1) {
	if (_.isNil(p)) {
		return 'n/a';
	}

	if (p === '-') {
		return '-';
	}
	return makePercentage(p, d) + '%';
}

const percentageToColor = {};
let r = 255;
let g = 255;
let b = 255;

// rgb(245, 249, 246) 1%

const MAX_PERCENTAGE = 80;
const MIN_PERCENTAGE = 30;

_.range(64, MAX_PERCENTAGE + 1).forEach((i) => {
	percentageToColor[i] = { r, g, b };
	r -= 4.5;
	g -= 2.5;
	b -= 3.5;
});

r = 255;
g = 255;
b = 255;

_.range(64, MIN_PERCENTAGE - 1).forEach((i) => {
	percentageToColor[i] = { r: _.round(r), g, b };
	r -= 0.25;
	g -= 2.5;
	b -= 2.5;
});

export function pToC(p) {
	let v = _.round(makePercentage(p));
	let r, g, b;
	if (v >= MAX_PERCENTAGE) {
		({ r, g, b } = percentageToColor[MAX_PERCENTAGE]);
	} else if (v <= MIN_PERCENTAGE) {
		({ r, g, b } = percentageToColor[MIN_PERCENTAGE]);
	} else {
		({ r, g, b } = percentageToColor[v] || percentageToColor[0]);
	}
	return `rgb(${r}, ${g}, ${b})`;
}

export function daysOnTimeToColor(p) {
	let v = _.round(makePercentage(p));
	let r, g, b;
	({ r, g, b } = percentageToColor[v] || percentageToColor[0]);
	return `rgb(${r}, ${g}, ${b})`;
}

export function lateToColor(v) {
	if (!v) {
		return `none`;
	} else if (v === 1) {
		return `rgb(254, 243, 243)`;
	} else if (v === 2) {
		return `rgb(254, 233, 233)`;
	} else if (v >= 2) {
		return `rgb(254, 203, 203)`;
	}
}

export function noNsToColor(v) {
	if (!v) {
		return `none`;
	} else if (v === 1) {
		return `rgb(254, 223, 223)`;
	} else if (v === 2) {
		return `rgb(254, 183, 183)`;
	}
}

export function missingToColor(v) {
	if (!v) {
		return `none`;
	} else if (v === 1) {
		return `rgb(254, 223, 223)`;
	} else if (v >= 2) {
		return `rgb(254, 203, 203)`;
	}
}

export function diffToColor(v) {
	if (!_.isNumber(v)) {
		return `none`;
		// too early
	} else if (v <= -30) {
		return `rgb(254, 203, 203)`;
	} else if (v >= 30) {
		return `rgb(254, 203, 203)`;
	} else if (v > 15) {
		return `rgb(254, 233, 233)`;
	} else if (v > 0) {
		return `rgb(254, 243, 243)`;
	} else if (v <= 0) {
		return `rgb(219, 235, 227)`;
	} else {
		return 'none';
	}
}
